import Mun from "./Mun"

class Banker extends Mun {
}

export default Banker
